
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[roomId]",
      function () {
        return require("private-next-pages/[roomId].tsx");
      }
    ]);
  